import React from 'react';
import type { SxProps, Theme } from '@mui/material/styles';
import {
  PageRoot,
  PageScrollArea,
  Wrapper,
  OuterContainer,
  InnerContainer,
} from '../PageContainer';
import {
  contentPageRootSx,
  contentPageScrollAreaSx,
  contentPageWrapperSx,
  contentPageOuterContainerSx,
  contentPageInnerContainerSx,
} from './contentPageLayoutSx';

export interface ContentPageLayoutProps {
  children: React.ReactNode;
  pageUi?: string;
  innerContainerSx?: SxProps<Theme>;
}

const ContentPageLayout: React.FC<ContentPageLayoutProps> = ({
  children,
  pageUi,
  innerContainerSx,
}) => (
  <PageRoot sx={contentPageRootSx}>
    <PageScrollArea sx={contentPageScrollAreaSx}>
      <Wrapper data-ui={pageUi} sx={contentPageWrapperSx}>
        <OuterContainer sx={contentPageOuterContainerSx}>
          <InnerContainer
            sx={
              innerContainerSx
                ? ([contentPageInnerContainerSx, innerContainerSx] as SxProps<Theme>)
                : contentPageInnerContainerSx
            }
          >
            {children}
          </InnerContainer>
        </OuterContainer>
      </Wrapper>
    </PageScrollArea>
  </PageRoot>
);

export default ContentPageLayout;
